export default __webpack_public_path__ + "media/images/theme_apple/on_off-e0f976e8402e2b217b32bc08e62ebc47.png";